import { __decorate } from "tslib";
import { Component } from 'decorators';
import tableRowComponent from './tableRow.view.html';
import './tableRow.scss';
let TableRowComponent = class TableRowComponent {
};
TableRowComponent = __decorate([
    Component({
        controllerAs: '$ctrl',
        bindings: {
            blocks: '<',
            confirm: '&',
        },
        template: tableRowComponent,
    })
], TableRowComponent);
export { TableRowComponent };
